<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-3/12 sm:w-3/12 w-full" ref="SmsSideNav">
        <send-message-form
          :remaining-balance="remainingBalance"
          :callbackNumber="activeCallbackNumber"
          :sendImage="sendImage"
          @messageSent="reloadData"
          @editCallbackNumber="activeTabIndex = 1"></send-message-form>
      </div>
      <div class="vx-col md:w-9/12 sm:w-9/12 w-full" ref="SmsMain">
        <vs-tabs :value="activeTabIndex">
          <vs-tab :label="$tc('template', 2)" style="min-height: 300px;">
            <div class="tab-text">
              <v-select :options="categoryOptions" :reduce="label => label.value" :placeholder="$t('category')" v-model="selectedCategory" class="mt-4 mb-4" />
              <message-template :templates="templates" @selectTemplate="changeSmsMessageContent"></message-template>
            </div>
          </vs-tab>
          <vs-tab :label="$t('callback_number')">
            <shared-messages-callback-number-list
              :callbackNumbers="callbackNumbers"
              @loadCallbackList="reloadData">
            </shared-messages-callback-number-list>
          </vs-tab>
          <vs-tab :label="$t('history')">
            <div class="tab-text">
              <vs-table hover-flat v-if="histories && histories.length" :data="histories">
                <template slot="thead">
                  <vs-th v-text="$t('receiver')"></vs-th>
                  <vs-th v-text="$t('agent')"></vs-th>
                  <vs-th v-text="$tc('message')"></vs-th>
                  <vs-th class="text-center" v-text="$t('action')"></vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td v-text="tr.receiver"></vs-td>
                    <vs-td v-text="tr.agent_name"></vs-td>
                    <vs-td>
                      <vs-textarea readonly v-model="tr.content"/>
                    </vs-td>
                    <vs-td>
                      <div class="flex justify-center">
                        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-send" size="small" @click="sendMessageByHistory(tr.receiver, tr.content)">
                          {{ $t('send_sms') }}
                        </vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
                <div v-text="$t('no_record')"></div>
              </vs-alert>
            </div>
          </vs-tab>
          <vs-tab :label="$t('send_image')">
            <div class="tab-text">
              <send-image-message-form v-model="sendImage" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import MessageTemplate from '@/views/Shared/Messages/Templates/List'
import SendMessageForm from '@/views/Shared/Messages/Form'
import SendImageMessageForm from '@/views/Shared/Messages/ImageForm'
import Template from '@/models/Template'
import History from '@/models/History'
import Message from '@/models/Message'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Shared.Messages.Send',
  components: {
    SendMessageForm,
    SendImageMessageForm,
    MessageTemplate,
    SharedMessagesCallbackNumberList: () => import('@/views/Shared/Messages/CallbackNumbers/List')
  },
  data () {
    return {
      companyId: '',
      selectedCategory: '',
      templates: {},
      categoryOptions: [],
      balance: {},
      activeCallbackNumber: '',
      activeTabIndex: 0,
      callbackNumbers: {},
      histories: {},
      sendImage: {
        file1: null,
        file2: null,
        file3: null
      }
    }
  },
  watch: {
    async selectedCategory (val) {
      try {
        const response = await Template.all({ id: val })
        this.templates = response.data.data.templates
      } catch (e) {
        this.$alertHelper.error(e)
      }
    }
  },
  computed: {
    remainingBalance () {
      if (this.balance) {
        return this.balance.total_loaded_sms - ((this.balance.total_sent_lms * 3) + this.balance.total_sent_sms)
      }
      return 0
    },

    currentRoute () {
      return this.$store.getters.currentRoute
    },
    hasToken () {
      return this.$store.getters.token !== '' && this.$store.getters.token !== null
    },
    isCtiWindow () {
      if (typeof this.currentRoute.name !== 'undefined') {
        return this.currentRoute.name.includes('cti.window') && this.hasToken
      }
      return false // false
    }
  },
  mounted () {
    this.loadComponentData()

    this.$windowOpenerHelper.listenToPopUpMessage('reload_message_callback_table', this.loadComponentData)

    document.onreadystatechange = () => {
      if (this.isCtiWindow) {
        this.onWindowResize()
        window.onresize = () => {
          this.onWindowResize()
        }
      }
    }

    EventBus.$on('setGivenNumber', async (number) => {
      if (number.length > 0) {
        this.getReceiverByNumber(number)
      }
    })
  },
  methods: {
    reloadData () {
      this.loadComponentData()
    },
    async loadComponentData (page) {

      let number = ''
      if (this.$route.params.number !== 'undefined') {
        number = this.$route.params.number
      }

      const response = await Message.templates({ page, number })
      this.templates = response.data.data.templates
      this.companyId = response.data.meta.companyId
      this.balance = response.data.meta.balance
      this.categoryOptions = response.data.meta.options.categories
      this.activeCallbackNumber = response.data.meta.activeCallbackNumber
      this.callbackNumbers = response.data.meta.callbackNumbers.data.callbackNumbers
      this.histories = response.data.meta.histories
    },
    changeSmsMessageContent (content) {
      EventBus.$emit('smsTemplateContentClicked', content)
    },
    onWindowResize () {
      if (window.innerWidth > 767) {
        const width = this.$refs.SmsSideNav.offsetWidth

        this.$refs.SmsSideNav.style.position = 'fixed'
        this.$refs.SmsMain.style.marginLeft = `${width - 5}px`
      } else {
        this.$refs.SmsSideNav.style.position = 'relative'
        this.$refs.SmsMain.style.marginLeft = 0
      }
    },

    async getReceiverByNumber (number) {
      const response = await History.getByReceiverNumber({ number })
      this.histories = response.data.data.messages
    },

    async sendMessageByHistory (number, message) {
      if (this.remainingBalance > 0) {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('are_you_sure_you_want_to_send_this_message'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })

        if (confirm.value) {
          try {
            await Message.send({
              message,
              number
            })

            this.$swalHelper.success({
              title: this.$t('has_been_sent'),
              text: this.$t('message_successfully_sent'),
              confirmButton: this.$t('confirm')
            })

            this.getReceiverByNumber(number)
          } catch (e) {
            this.$swalHelper.displayCatchError({
              title: 'Error!',
              errorObject: e,
              confirmButton: this.$t('confirm')
            })
          }
        }

      } else {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: this.$t('send_sms_not_enough_balance'),
          confirmButton: this.$t('confirm')
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
